import { createFileRoute } from "@tanstack/react-router";
import { sciHead } from "@/lib/science/sci-route";
import { m } from "@/paraglide/messages";
import { CalculatorPage } from "@/tools/gc-skew/pages/CalculatorPage";

export const Route = createFileRoute("/gc-skew")({
  ssr: true,
  head: () =>
    sciHead({
      basePath: "/gc-skew",
      title: m.gcskew_meta_title(),
      description: m.gcskew_meta_description(),
      toolName: m.gcskew_tool_name(),
      faqs: [
        { q: m.gcskew_faq_q1(), a: m.gcskew_faq_a1() },
        { q: m.gcskew_faq_q2(), a: m.gcskew_faq_a2() },
        { q: m.gcskew_faq_q3(), a: m.gcskew_faq_a3() },
        { q: m.gcskew_faq_q4(), a: m.gcskew_faq_a4() },
      ],
    }),
  component: CalculatorPage,
});
